import axios from "axios";
import { toast } from "react-toastify";

// Guards against a second click while a request is in flight.
let inFlight = false;

// The tab is script-opened, so only navigate it to a well-formed token on an
// http(s) URL.
const isSafeTarget = (baseUrl, token) => {
  if (typeof token !== "string" || !/^[0-9a-f]{64}$/.test(token)) return false;
  try {
    const { protocol } = new URL(baseUrl + token);
    return protocol === "http:" || protocol === "https:";
  } catch (e) {
    return false;
  }
};

/**
 * Opens the company / company-user portal in a new tab as the given target.
 *
 * Must be called synchronously from a click handler: the blank tab is opened
 * before any await so popup blockers allow it. The token is single use and
 * valid for 60 seconds, so the tab is navigated as soon as it is minted.
 */
export const impersonate = async ({ endpoint, params = {}, baseUrl }) => {
  if (inFlight) return;

  const w = window.open("", "_blank");
  if (!w) {
    toast.error("Please allow popups for this site and try again.");
    return;
  }
  try {
    w.opener = null;
  } catch (e) {
    // ignore: some browsers do not allow setting opener
  }

  inFlight = true;
  try {
    const bodyFormData = new URLSearchParams();
    bodyFormData.append("auth_code", process.env.REACT_APP_AUTH_CODE);
    bodyFormData.append("masterId", sessionStorage.getItem("TES_Admin_ID"));
    const sessionKey = sessionStorage.getItem("TES_Session_Key");
    if (sessionKey) {
      bodyFormData.append("session_key", sessionKey);
    }
    Object.keys(params).forEach((key) => {
      bodyFormData.append(key, params[key]);
    });

    const response = await axios.post(
      `${process.env.REACT_APP_base_url}api/masterAdmin/${endpoint}`,
      bodyFormData,
      { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
    );

    const token =
      response.data && response.data.data && response.data.data.token;
    const targetUrl = isSafeTarget(baseUrl, token) ? baseUrl + token : null;
    if (response.data && response.data.success === true && targetUrl) {
      w.location.href = targetUrl;
    } else {
      w.close();
      toast.error("Something went wrong");
    }
  } catch (error) {
    w.close();
    const status = error.response && error.response.status;
    if (status === 403) {
      toast.error("Your session has expired. Please log out and log in again.");
    } else if (status === 404) {
      toast.error("Company or user not found or unavailable.");
    } else {
      toast.error("Something went wrong");
    }
  } finally {
    inFlight = false;
  }
};
